/**
 * @generated SignedSource<<ac6b8be11c15cb6c1baf4b7de42447ab>>
 * @relayHash e6ce8891e2d9d5d8128910851d10589e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 416f890e7d405956653c686dfa9abcf1cb22cb73ce70c189fdabdd5140db1e09

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { BacklogAggAppDataQuery } from './BacklogAggAppDataQuery.graphql';

const node: PreloadableConcreteRequest<BacklogAggAppDataQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "416f890e7d405956653c686dfa9abcf1cb22cb73ce70c189fdabdd5140db1e09",
    "metadata": {},
    "name": "BacklogAggAppDataQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
